import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

export function selectIsChatEnabled(offer: IDailyRentOfferForMobileSite): boolean {
  return offer.author?.isChatsEnabled || false;
}
